module.exports = __webpack_public_path__ + "13362b1ef5b0066859a27cb4a843bfe8.svg";